import { render, staticRenderFns } from "./DetailsPageGen.vue?vue&type=template&id=3ce1aa26&"
import script from "./DetailsPageGen.vue?vue&type=script&lang=js&"
export * from "./DetailsPageGen.vue?vue&type=script&lang=js&"
import style0 from "./DetailsPageGen.vue?vue&type=style&index=0&id=3ce1aa26&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports